<div class="min-h-screen bg-[var(--color-background)] p-6">

  <div class="max-w-6xl mx-auto space-y-6">

    <!-- Header -->
    <div class="flex items-end justify-between">

      <div>
        <h1 class="text-2xl font-bold text-[var(--color-secondary)]">
          Overview
        </h1>

        <p class="text-sm text-[var(--color-muted-foreground)] mt-1">
          Track system performance at a glance
        </p>
      </div>

      <div
        class="px-4 py-2 rounded-2xl
               bg-[var(--color-primary-light)]
               text-[var(--color-primary)]
               text-sm font-semibold"
      >
        Live Stats
      </div>

    </div>

    <!-- Stats Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">

      <!-- Stat Card -->
      <div class="glass-card rounded-3xl p-5 hover:scale-[1.02] transition">

        <div class="flex items-center justify-between">

          <div>
            <p class="text-xs text-[var(--color-muted-foreground)]">
              Total Users
            </p>

            <h2 class="text-2xl font-bold text-[var(--color-secondary)] mt-1">
              1,248
            </h2>
          </div>

          <div
            class="w-12 h-12 rounded-2xl
                   flex items-center justify-center
                   bg-[var(--color-primary-light)]
                   text-[var(--color-primary)]"
          >
            <i class="bi bi-people-fill text-lg"></i>
          </div>

        </div>

        <p class="text-xs text-green-600 mt-3">
          +12% this month
        </p>

      </div>

      <!-- Stat Card -->
      <div class="glass-card rounded-3xl p-5 hover:scale-[1.02] transition">

        <div class="flex items-center justify-between">

          <div>
            <p class="text-xs text-[var(--color-muted-foreground)]">
              Active Subjects
            </p>

            <h2 class="text-2xl font-bold text-[var(--color-secondary)] mt-1">
              6
            </h2>
          </div>

          <div
            class="w-12 h-12 rounded-2xl
                   flex items-center justify-center
                   bg-[var(--color-primary-light)]
                   text-[var(--color-primary)]"
          >
            <i class="bi bi-journal-bookmark-fill text-lg"></i>
          </div>

        </div>

        <p class="text-xs text-[var(--color-muted-foreground)] mt-3">
          Updated weekly
        </p>

      </div>

      <!-- Stat Card -->
      <div class="glass-card rounded-3xl p-5 hover:scale-[1.02] transition">

        <div class="flex items-center justify-between">

          <div>
            <p class="text-xs text-[var(--color-muted-foreground)]">
              Quizzes Taken
            </p>

            <h2 class="text-2xl font-bold text-[var(--color-secondary)] mt-1">
              342
            </h2>
          </div>

          <div
            class="w-12 h-12 rounded-2xl
                   flex items-center justify-center
                   bg-[var(--color-primary-light)]
                   text-[var(--color-primary)]"
          >
            <i class="bi bi-award-fill text-lg"></i>
          </div>

        </div>

        <p class="text-xs text-green-600 mt-3">
          +8% improvement
        </p>

      </div>

      <!-- Stat Card -->
      <div class="glass-card rounded-3xl p-5 hover:scale-[1.02] transition">

        <div class="flex items-center justify-between">

          <div>
            <p class="text-xs text-[var(--color-muted-foreground)]">
              System Sync
            </p>

            <h2 class="text-2xl font-bold text-[var(--color-secondary)] mt-1">
              Online
            </h2>
          </div>

          <div
            class="w-12 h-12 rounded-2xl
                   flex items-center justify-center
                   bg-[var(--color-primary-light)]
                   text-[var(--color-primary)]"
          >
            <i class="bi bi-cloud-check-fill text-lg"></i>
          </div>

        </div>

        <p class="text-xs text-[var(--color-primary)] mt-3">
          Last sync: 2 min ago
        </p>

      </div>

    </div>

    <!-- Placeholder Section -->
    <div class="glass-card rounded-3xl p-6">

      <h3 class="text-lg font-semibold text-[var(--color-secondary)]">
        Activity Feed
      </h3>

      <p class="text-sm text-[var(--color-muted-foreground)] mt-2">
        This area will show recent student activity, quiz submissions, and system events.
      </p>

      <!-- Fake skeleton -->
      <div class="mt-5 space-y-3">

        <div class="h-3 w-full bg-[var(--color-muted)] rounded"></div>
        <div class="h-3 w-5/6 bg-[var(--color-muted)] rounded"></div>
        <div class="h-3 w-4/6 bg-[var(--color-muted)] rounded"></div>

      </div>

    </div>

  </div>

</div>